import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import art from "../assets/images/art.png"
import photo from "../assets/images/camera.png"
import memes from "../assets/images/memes.png"
import ar from "../assets/images/AR.png"
import jokes from "../assets/images/jokes.png"
import videos from "../assets/images/videos.png"
import dialogues from "../assets/images/dialogues.png"
import music from "../assets/images/music.png"
import { graphql, useStaticQuery } from "gatsby"

const NFTList = () => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        nft_list_heading
      }
    }
  `)

  const {
    strapiHomePage: { nft_list_heading },
  } = data

  return (
    <Container className="nft-list">
      <h1 className="text-start text-lg-center text-md-center my-0 my-lg-5">
        {nft_list_heading}
      </h1>
      <Row className="justify-content-center align-items-center">
        <Col lg={3} xs={6} className="text-center my-5">
          <img src={art} alt="art" />
          <p className="my-3">ART</p>
        </Col>
        <Col lg={3} xs={6} className="text-center my-5">
          <img src={photo} alt="art" />
          <p className="my-3">PHOTOGRAPHY</p>
        </Col>
        <Col lg={3} xs={6} className="text-center my-5">
          <img src={memes} alt="art" />
          <p className="my-3">MEMES</p>
        </Col>
        <Col lg={3} xs={6} className="text-center my-5">
          <img src={ar} alt="art" />
          <p className="my-3">AR</p>
        </Col>
        <Col lg={3} xs={6} className="text-center my-5 my-lg-0">
          <img src={jokes} alt="art" />
          <p className="my-3">JOKES</p>
        </Col>
        <Col lg={3} xs={6} className="text-center my-5 my-lg-0">
          <img src={videos} alt="art" />
          <p className="my-3">VIRAL VIDEOS</p>
        </Col>
        <Col lg={3} xs={6} className="text-center my-5 my-lg-0">
          <img src={dialogues} alt="art" />
          <p className="my-3">PUNCH DIALOGUES</p>
        </Col>
        <Col lg={3} xs={6} className="text-center my-5 my-lg-0">
          <img src={music} alt="art" />
          <p className="my-3">MUSIC</p>
        </Col>
      </Row>
    </Container>
  )
}

export default NFTList
